import { useRef } from 'react'

export default function useDebounceCallback<T>(delay: number, callback: (args: T) => void) {
  const thisTimeout = useRef<NodeJS.Timeout>()

  return (args: T) => {
    if (thisTimeout.current) {
      clearTimeout(thisTimeout.current)
    }
    thisTimeout.current = setTimeout(() => {
      callback(args)
    }, delay)
  }
}
